
import { defineComponent } from 'vue';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import HostUtils from '@/utils/HostUtils';

export default defineComponent({
    emits: ['hide'],
    methods: {
        dismiss() {
            theLocalStorageUtils.save(LocalStorageKeys.showBannerAnnouncements, 'false');
            this.$emit('hide');

            // Wait for the banner to be removed from the DOM so the grid resizes against its new height.
            this.$nextTick(() => {
                (this as any).eventBus.emit('resizeWindowGrid');
            });
        },
        getLink(): string {
            let result = `https://help.alamode.com/kb/guide/en/CFWJa1CFDY/Steps/6067854`;
            if (HostUtils.isTotal()) {
                result = `https://help.alamode.com/kb/guide/en/CFWJa1CFDY/Steps/6067854/?popout=1`;
            }
            return result;
        },
        getTarget(): string {
            let result = `_blank`;
            if (HostUtils.isTotal()) {
                result = ``;
            }
            return result;
        },
    }
});
